module.exports = __webpack_public_path__ + "img/banner.14d5c309.gif";